import Pathword from './Pathword';

export default Pathword;